export default __webpack_public_path__ + "static/footer-logo-23c1a1adcfb5a0d061afacae5e1b9349.png";